import { useAppSelector } from "../../store/hooks";
import { getCompanyName, getLogo } from "../../store/reducers/auth/authSlice";
import { PageTitle } from "./Fonts";

const Logo = () => {
  const logo = useAppSelector(getLogo);
  const name = useAppSelector(getCompanyName);

  if (!logo) {
    return <PageTitle className={"!mb-0"}>{name}</PageTitle>;
  } else {
    return (
      <div className="flex items-center">
        <img
          src={logo}
          alt={name}
          className="max-w-[8rem] md:max-w-[12rem] max-h-12"
        />
      </div>
    );
  }
};

export default Logo;
